'use strict';

import jQuery from 'jquery';
import ga from './../../vendor/google-analytics';

/**
 * Passport
 *
 * JavaScript functions for the general Passport pages
 */
var Passport = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function() {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);
      
      // Attach the sign in event handlers
      privateNS.attachHandlers();
    };

    /**
     * Tracks all Passport state elements on the page back to Google Analytics
     */
    privateNS.trackPassportState = function trackPassportState() {

      // Find all elements that are marked as Passport tracking
      $('.passport-state-tracking').each(function trackStateElement() {

        // Get the current element
        var $this = $(this);

        // For each element track the state to GA based on its properties
        ga(
          'send',
          'event',
          $this.attr('data-category'),
          $this.attr('data-action'),
          $this.attr('data-label')
        );
      });
    };

    /**
     * Handle page loads for all Passport pages
     *
     * @param {jQuery.event} $event The triggering jQuery event
     */
    privateNS.onPassportLoad = function onPassportLoad($event) {

      // Whenever a Passport page loads, track any Passport activation elements
      // that are present on the page
      privateNS.trackPassportState();
    };

    /**
     * Handles clicks on the Get Passport buttons to track their sources
     *
     * @param {jQuery.event} $event The triggering jQuery event
     */
    privateNS.onGetPassportClick = function onGetPassportClick($event) {

      // Track the click event back to analytics with the current url
      ga(
        'send',
        'event',
        'Passport',
        'Get Passport Source',
        window.location.href
      );
    };

    /**
     * Attach the event handlers for the show / episode page
     */
    privateNS.attachHandlers = function() {

      // Bind the click events of the various sign in options
      privateNS.$container.on(
        'click',
        '.get-passport',
        privateNS.onGetPassportClick
      );

      // Bind the load event of the Passport pages
      $(window).on(
        'load',
        privateNS.onPassportLoad
      );
    };

    // Return a new instance
    return privateNS.init();
  };

})(jQuery);

export default Passport;